import { render } from "./Music.vue?vue&type=template&id=61df6c07"
import script from "./Music.vue?vue&type=script&lang=js"
export * from "./Music.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__